import { ReactNode } from 'react';

type PositionSummaryDetailProps = {
    title: string;
    value: ReactNode;
};

const PositionSummaryDetail: React.FC<PositionSummaryDetailProps> = ({
    title,
    value,
}) => (
    <div className='position-summary-detail'>
        <div className='title'>{title}</div>
        <div className='value'>{value}</div>
    </div>
);

export default PositionSummaryDetail;
